import React from 'react';
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { db, user } from '../../../../firebase';
import { collection, getDocs, where, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore'; 
import PortfolioHeader from '../Header';
import PHP from './PHP';
import Python from './Python';

const Middleware = () => {
    const [link, setLink] = useState('php');
    const [portfolioData, setPortfolioData] = useState([]);
    
    useEffect(() => { 
        if(user) {
            fetchPortfolioData();
        }
    }, [])

    const fetchPortfolioData = async () => {
        const q = query(collection(db, 'portfolio'), where('project_type',"array-contains", 'visualdesign'));
        const querySnapshot = await getDocs(q);
        setPortfolioData(querySnapshot.docs.map(doc => ({
            id: doc.id,
            data: doc.data()    
        })));
    }
    useEffect(() => {
        // console.log(portfolioData);  
    }, [portfolioData])
    return (
        <>
            <PortfolioHeader />
            <div className="gearsBg">
                <div className="wheel8"></div>
                <div className="wheel9"></div>
                <div className="wheel10"></div>
                <ul className="innerTopNav">
                    <li><Link to="/portfolio/frontend"><span>Front-end Stack</span></Link></li>
                    <li><Link to="/portfolio/uiux"><span>UI/UX</span></Link></li>
                    <li><Link to="/portfolio/middleware"  className="active"><span>Middleware</span></Link></li>
                    <li><Link to="/portfolio/digitalmarketing" ><span>Digital Marketing</span></Link></li>
                </ul>
            </div>
            <div className="paper">
                <div className="top">&nbsp;</div>
                <div className="mid clearfix">
                    <div className="leftnav">
                        <ul id="leftnav">
                            <li><span className={link === 'php' ? 'active' : ''} onClick={() => { setLink('php') }}>PHP</span></li>
                            <li><span className={link === 'python' ? 'active' : ''} onClick={() => { setLink('python') }}> Python</span></li>
                           
                        </ul>
                    </div>
                    <div className="maincontent">
                        <div className="breadcrumb">
                            <Link to="/portfolio/home">Home</Link> » Middleware
                        </div>
                        {(
                            () => {
                                console.log();
                                switch (link) {
                                    case 'php':
                                        return <PHP />
                                    case 'python':
                                        return <Python />
                                    default:
                                        return null
                                }
                            }
                        )()} 
                    </div>
                </div>
                <div className="btm">&nbsp;</div>
            </div>
        </>
    )

}
export default Middleware;